import { render, staticRenderFns } from "./ConfirmEmailRequired.vue?vue&type=template&id=22c39eb4&scoped=true&"
import script from "./ConfirmEmailRequired.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailRequired.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailRequired.vue?vue&type=style&index=0&id=22c39eb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c39eb4",
  null
  
)

export default component.exports